import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import makeStyles from "@material-ui/core/styles/makeStyles";
import { Add } from "@material-ui/icons";
import Create from "@material-ui/icons/Create";
import GridContainer from "@jumbo/components/GridContainer";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { fetchError } from "redux/actions";
import EventsRequests from "services/events";
import FileUploader from "@jumbo/Dashboards/Media/FileUploader";
import ImagePicker from "@jumbo/Dashboards/Tests/compnents/ImagePicker";
import { TextField, Typography, Grid, Button, Box } from "@material-ui/core";
import CheckBox from "@jumbo/Dashboards/Banner/CheckBox";

import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import { useHistory } from "react-router";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  cardRoot: {
    paddingTop: "24px",
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
    paddingInline: "25px",
  },
  formContainer: {
    width: "100%",
  },
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "80%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  buttonContainer: {
    paddingInline: "40px !important",
    justifyContent: "flex-end",
  },
  label: {
    marginBottom: 20,
    fontWeight: "500",
  },
}));

const WGEventFields = () => {
  const now = new Date();
  now.setHours(18, 0, 0, 0);

  const history = useHistory();

  const dateFormat = {
    date: now,
    gregorian: new DateObject({ date: now, format: "HH:mm:ss   YYYY/MM/DD" })
      .convert(gregorian, gregorian_en)
      .format(),
  };

  const [eventTitle, setEventTitle] = useState("");
  const [eventSubTitle, setEventSubTitle] = useState("");
  const [eventDesc, setEventDesc] = useState("");
  const [eventPoster, setEventPoster] = useState("");
  const [questionPoster, setQuestionPoster] = useState("");
  const [active, setActive] = useState(false);
  const [archived, setArchived] = useState(false);
  const [maxWords, setMaxWords] = useState(0);
  const [maxDailyTickets, setMaxDailyTickets] = useState(0);
  const [pointsPerWord, setPointsPerWord] = useState(1);
  const [startDate, setStartDate] = useState(dateFormat);
  const [endDate, setEndDate] = useState(dateFormat);
  const [openFileUploader, setOpenFileUploader] = useState(false);
  const [openPosterUploader, setOpenPosterUploader] = useState(false);
  const [durationEnabled, setDurationEnabled] = useState(false);
  const [durationInMinutes, setDurationInMinutes] = useState(0);
  const [limitPerFamily, setLimitPerFamily] = useState(true);

  const classes = useStyles();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { singleWGEvent } = useSelector(({ events }) => events);

  useEffect(() => {
    if (id) {
      dispatch(EventsRequests.getWGEventById(id));
    }
  }, [id]);

  const convertFromDate = (date, format = startDate.format) => {
    let object = { date, format };
    setStartDate({
      gregorian: new DateObject(object)
        .convert(gregorian, gregorian_en)
        .format(),
      ...object,
    });
  };
  const convertToDate = (date, format = endDate.format) => {
    let object = { date, format };
    setEndDate({
      gregorian: new DateObject(object)
        .convert(gregorian, gregorian_en)
        .format(),
      ...object,
    });
  };

  const convertToStandardFormat = (dateString) => {
    const [time, date] = dateString.split("   ");
    const [hours, minutes, seconds] = time.split(":");
    const [year, month, day] = date.split("/");
    const standardFormat = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    const dateObject = new Date(standardFormat);
    const isoString = dateObject.toISOString();
    return isoString;
  };

  useEffect(() => {
    if (singleWGEvent) {
      if (singleWGEvent._id === id) {
        setEventTitle(singleWGEvent.title);
        setEventDesc(singleWGEvent.description);
        setEventSubTitle(singleWGEvent?.subtitle);
        setEventPoster(singleWGEvent?.poster);
        setQuestionPoster(singleWGEvent?.wordPoster);
        setPointsPerWord(singleWGEvent?.pointsPerWord);
        setActive(singleWGEvent?.active);
        setArchived(singleWGEvent?.archived);
        setMaxWords(singleWGEvent?.maxWords);
        setMaxDailyTickets(singleWGEvent?.maxDailyTickets);
        setDurationEnabled(singleWGEvent?.durationEnabled);
        setDurationInMinutes(singleWGEvent?.durationMinutes || 0);
        setLimitPerFamily(singleWGEvent?.limitPerFamily);
        setStartDate({
          date: singleWGEvent?.startDate,
          gregorian: new DateObject({
            date: singleWGEvent?.startDate,
            format: "HH:mm:ss   YYYY/MM/DD",
          })
            .convert(gregorian, gregorian_en)
            .format(),
        });
        setEndDate({
          date: singleWGEvent?.endDate,
          gregorian: new DateObject({
            date: singleWGEvent?.endDate,
            format: "HH:mm:ss   YYYY/MM/DD",
          })
            .convert(gregorian, gregorian_en)
            .format(),
        });
      }
    }
  }, [singleWGEvent]);

  const handleCreateTest = () => {
    if (eventTitle) {
      const createdEvent = {
        active: active,
        archived: archived,
        title: eventTitle,
        subtitle: eventSubTitle,
        description: eventDesc,
        poster: eventPoster,
        wordPoster: questionPoster,
        startDate: convertToStandardFormat(startDate.gregorian),
        endDate: convertToStandardFormat(endDate.gregorian),
        pointsPerWord: pointsPerWord,
        maxWords: maxWords,
        maxDailyTickets: maxDailyTickets,
        durationEnabled: durationEnabled,
        durationMinutes: +durationInMinutes,
        limitPerFamily: limitPerFamily,
      };
      dispatch(EventsRequests.createSingleWordGameEvent(createdEvent));
      setEventTitle("");
      setEventDesc("");
      setEventSubTitle("");
      setEventPoster("");
      setQuestionPoster("");
      setActive(false);
      setArchived(false);
      setMaxWords(0);
      setMaxDailyTickets(0);
      setPointsPerWord(1);
      setStartDate(dateFormat);
      setEndDate(dateFormat);
      setDurationEnabled(false);
      setDurationInMinutes(0);
      setLimitPerFamily(true);
      history.replace("/wordGame/events");
    } else {
      dispatch(fetchError("موارد لازم را به درستی وارد نمایید"));
    }
  };

  const handleUpdateEvent = () => {
    if (eventDesc || eventTitle) {
      const updatedEvent = {
        active: active,
        archived: archived,
        title: eventTitle,
        subtitle: eventSubTitle,
        description: eventDesc,
        poster: eventPoster,
        startDate: convertToStandardFormat(startDate.gregorian),
        endDate: convertToStandardFormat(endDate.gregorian),
        pointsPerWord: pointsPerWord,
        maxWords: maxWords,
        maxDailyTickets: maxDailyTickets,
        wordPoster: questionPoster,
        durationEnabled: durationEnabled,
        durationMinutes: +durationInMinutes,
        limitPerFamily: limitPerFamily,
      };
      dispatch(EventsRequests.updateWGEvent(id, updatedEvent));
    } else {
      dispatch(fetchError("موارد لازم را به درستی وارد نمایید"));
    }
  };

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <form className={classes.formContainer} noValidate autoComplete="off">
          <Grid item xs={12}>
            <CheckBox
              name={"active"}
              title={"فعال"}
              value={active}
              handleChange={(e) => setActive(e.target.checked)}
            />
          </Grid>
          <Grid item xs={12}>
            <CheckBox
              name={"archived"}
              title={"آرشیو"}
              value={archived}
              handleChange={(e) => setArchived(e.target.checked)}
            />
          </Grid>
          <GridContainer className={classes.girdContainer}>
            <Grid item xs={12}>
              <Typography className={classes.label}>نام رخداد</Typography>
              <TextField
                id="eventNameField"
                label="نام رخداد"
                variant="outlined"
                className={classes.customInput}
                value={eventTitle}
                onChange={(e) => setEventTitle(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.label}>زیر‌عنوان</Typography>
              <TextField
                id="subtitleField"
                label="زیر‌عنوان"
                variant="outlined"
                className={classes.formControl}
                value={eventSubTitle}
                onChange={(e) => setEventSubTitle(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.label}>انتخاب پوستر</Typography>
              <ImagePicker
                cover={eventPoster}
                handlePick={() => setOpenFileUploader(true)}
                handleRevome={() => setEventPoster("")}
                previewStyles={{ marginInline: "auto", marginBlock: "20px" }}
                placeHolderStyles={{
                  marginInline: "auto",
                  marginBlock: "20px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.label}>
                انتخاب پوستر سوال
              </Typography>
              <ImagePicker
                cover={questionPoster}
                handlePick={() => setOpenPosterUploader(true)}
                handleRevome={() => setQuestionPoster("")}
                previewStyles={{ marginInline: "auto", marginBlock: "20px" }}
                placeHolderStyles={{
                  marginInline: "auto",
                  marginBlock: "20px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.label}>توضیحات رخداد</Typography>
              {/* <TextField
                id="eventDescField"
                multiline
                minRows={4}
                label="توضیحات"
                variant="outlined"
                className={classes.customInput}
                value={eventDesc}
                onChange={(e) => setEventDesc(e.target.value)}
              /> */}
              <CKEditor
                editor={ClassicEditor}
                config={{
                  language: "fa",
                  toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "blockQuote",
                  ],
                  link: {
                    addTargetToExternalLinks: true,
                    decorators: [
                      {
                        mode: "manual",
                        label: "باز کردن در تب جدید",
                        attributes: {
                          target: "_blank",
                        },
                      },
                    ],
                  },
                }}
                data={eventDesc}
                onChange={(_, editor) => {
                  const data = editor.getData();
                  setEventDesc(data);
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography className={classes.label}>
                جایزه سکه راه بهشت
              </Typography>
              <TextField
                id="pointsPerWordField"
                label="جایزه سکه راه بهشت"
                variant="outlined"
                type="number"
                className={classes.customInput}
                value={pointsPerWord}
                onChange={(e) => setPointsPerWord(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography className={classes.label}>حداکثر کلمات</Typography>
              <TextField
                id="maxWordsField"
                label="حداکثر کلمات"
                variant="outlined"
                type="number"
                className={classes.customInput}
                value={maxWords}
                onChange={(e) => setMaxWords(e.target.value)}
                helperText={"0 یعنی بی‌نهایت"}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography className={classes.label}>
                حداکثر تعداد کلمه روزانه{" "}
              </Typography>
              <TextField
                id="dailyTicketsField"
                label="حداکثر تعداد کلمه روزانه"
                variant="outlined"
                type="number"
                className={classes.customInput}
                value={maxDailyTickets}
                onChange={(e) => setMaxDailyTickets(e.target.value)}
                helperText={"0 یعنی بی‌نهایت"}
              />
            </Grid>
            <Grid item xs={12} md={6}></Grid>
            <Grid item xs={12} md={6}>
              <Box display={"flex"} alignItems="center">
                <CalendarTodayIcon fontSize="small" />
                <Box marginLeft={2}>
                  <Typography>تاریخ شروع</Typography>
                </Box>
              </Box>

              <DatePicker
                containerClassName="custom-container"
                calendar={persian}
                locale={persian_fa}
                calendarPosition="top-right"
                value={startDate.date}
                onChange={convertFromDate}
                format="HH:mm:ss   YYYY/MM/DD"
                plugins={[<TimePicker position="right" />]}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box display={"flex"} alignItems="center">
                <CalendarTodayIcon fontSize="small" />
                <Box marginLeft={2}>
                  <Typography>تاریخ پایان</Typography>
                </Box>
              </Box>
              <DatePicker
                containerClassName="custom-container"
                calendar={persian}
                locale={persian_fa}
                calendarPosition="bottom-right"
                value={endDate.date}
                onChange={convertToDate}
                format="HH:mm:ss   YYYY/MM/DD"
                plugins={[<TimePicker position="right" />]}
              />
            </Grid>

            <Grid item md={6} xs={12}>
              <CheckBox
                name={"active"}
                title={"محدودیت زمانی"}
                value={durationEnabled}
                handleChange={(e) => setDurationEnabled(e.target.checked)}
              />
              <Typography className={classes.label}>فرصت پاسخگویی</Typography>
              <TextField
                id="dailyTicketsField"
                label="فرصت پاسخگویی"
                variant="outlined"
                type="number"
                className={classes.customInput}
                value={durationInMinutes}
                onChange={(e) => setDurationInMinutes(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <CheckBox
                name={"limitPerFamily"}
                title={"کد پرسنلی یکتا"}
                value={limitPerFamily}
                handleChange={(e) => setLimitPerFamily(e.target.checked)}
              />
            </Grid>

            <Grid item xs={12} container className={classes.buttonContainer}>
              {id ? (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    startIcon={<Create />}
                    onClick={handleUpdateEvent}
                  >
                    ویرایش رخداد
                  </Button>
                </>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  startIcon={<Add />}
                  onClick={handleCreateTest}
                >
                  ساخت رخداد
                </Button>
              )}
            </Grid>
          </GridContainer>
        </form>
      </CmtCardContent>
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={(selected) => setEventPoster(selected)}
        selectedItem={eventPoster}
        imageSelector={true}
      />
      <FileUploader
        selectMode
        open={openPosterUploader}
        handleClose={() => setOpenPosterUploader(false)}
        handleSelect={(selected) => setQuestionPoster(selected)}
        selectedItem={questionPoster}
        imageSelector={true}
      />
    </CmtCard>
  );
};

export default WGEventFields;
